import * as React from 'react';
import { connect } from 'react-redux';
import { withRouter, Link } from 'react-router-dom';
import PropTypes from 'prop-types';
import isEmpty from 'lodash/isEmpty';
import './Header.css';
import { routesAction } from '../../shared/helpers';
import Logo from './Logo.svg';
import ProfilePic from './profile-pic.svg';
import plusIcon from './plus-icon.svg';
import NotificationList from './../NotificationList';
import { createNewProject } from '../../store/actions/Dashboard';
import { updateNotification } from '../../store/actions/Notification';
import { resetWizard } from '../../store/actions/OnboardingRedesign';

class Header extends React.Component {
  constructor(props) {
    super(props);
    this.handleOpenNotifications = this.handleOpenNotifications.bind(this);
    this.handleGoBack = this.handleGoBack.bind(this);
    this.handleCreateProject = this.handleCreateProject.bind(this);
    this.handleLogout = this.handleLogout.bind(this);
    this.state = {
      activeHeader: false,
      activeNotifications: false,
    };
  }

  handleOpenNotifications() {
    const { handleGetNotifications } = this.props;
    this.dropdownRef.current.classList.remove('show');
    this.setState({
      activeNotifications: !this.state.activeNotifications,
      activeHeader: false,
    });

    handleGetNotifications();
  }

  handleGoToProfile = () => {
    this.props.history.push(routesAction.myProfile());
  };

  handleGoBack() {
    this.props.history.goBack();
  }

  handleCreateProject() {
    this.props.dispatchResetWizard();
    this.props.history.push(routesAction.onboarding());
  }

  handleLogout(e) {
    e.preventDefault();
    this.props.history.replace('', null);
    this.props.handleLogout();
  }

  render() {
    const {
      isLogin,
      user: { avatar_url: avatarUrl, name, type },
      isNewNotifications,
      notifications,
      dispatchMarkAsRead,
    } = this.props;
    const currentLocation = this.props.location.pathname;
    const allProjectsLink =
      currentLocation === '/' ? (
        <li
          className="py-4"
          style={{
            borderBottom: '3px #259F96 solid',
          }}
        >
          <p className="nav-link text-darkgreen mx-3 px-0 t-16">All Projects</p>
        </li>
      ) : (
        <li className="py-4">
          <a href="/" className="nav-link text-primary mx-3 px-0 t-16">
            All Projects
          </a>
        </li>
      );
    const isClient = type === 'Client';
    const locationHeaders =
      currentLocation === '/onboarding' ? (
        <React.Fragment>
          <li>
          {/*  <p className="nav-link text-darkgreen mx-3 px-0">
              Questions?&nbsp;
              <a href="tel:855-431-7335">
                <span className="btn-txt text-darkgreen">(855) 431-7335</span>
              </a>
            </p>*/}
          </li>
          <li className="py-3">
            <div className="separator d-none d-lg-inline-block ml-3" />
          </li>
        </React.Fragment>
      ) : (
        <React.Fragment>
          <li>
            {isClient && (
              <a
                onClick={this.handleCreateProject}
                className="nav-link text-primary px-0"
              >
                <button className="dropbox-button small">
                  <img src={plusIcon} className="dropbox-content" />
                </button>{' '}
                New Project
              </a>
            )}
          </li>
          <li className="py-3">
            <div className="separator d-none d-lg-inline-block ml-3" />
          </li>
          {allProjectsLink}
        </React.Fragment>
      );

    this.dropdownRef = React.createRef();
    this.notificationsRef = React.createRef();

    const mobileAllProjectsLink =
      currentLocation === '/' ? (
        <li className="text-center">
          <p className="nav-link text-center text-darkgreen mx-3 px-0 t-16">
            All projects
          </p>
        </li>
      ) : (
        <li>
          <a
            href="/"
            className="nav-link text-center text-primary mx-3 px-0 t-16"
          >
            All projects
          </a>
        </li>
      );
    const mobileLocationHeaders =
      currentLocation === '/onboarding' ? (
        <React.Fragment>
          {mobileAllProjectsLink}
          <li>
            {isClient && (
              <a
                className="nav-link text-center text-primary mx-3 px-0 t-16"
                href="/my-profile"
              >
                Edit Profile
              </a>
            )}
          </li>
          <li>
            <p className="nav-link text-darkgreen mx-3 px-0">
              Questions?&nbsp;
              <a href="tel:855-431-7335">
                <span className="btn-txt text-darkgreen">(855) 431-7335</span>
              </a>
            </p>
          </li>
        </React.Fragment>
      ) : (
        <React.Fragment>
          {mobileAllProjectsLink}
          <li>
            <React.Fragment>
              <a
                className="nav-link text-center text-primary mx-3 px-0 t-16"
                onClick={() => {
                  this.handleGoToProfile();
                  this.dropdownRef.current.classList.remove('show');
                  this.notificationsRef.current.classList.remove('show');
                  this.setState({
                    activeHeader: false,
                    activeNotifications: false,
                  });
                }}
              >
                Edit Profile
              </a>
              {isClient && (
                <a
                  onClick={() => {
                    this.handleCreateProject();
                    this.dropdownRef.current.classList.remove('show');
                    this.notificationsRef.current.classList.remove('show');
                    this.setState({
                      activeNotifications: false,
                      activeHeader: false,
                    });
                  }}
                  className="nav-link text-primary px-0"
                >
                  <button className="dropbox-button small">
                    <img src={plusIcon} className="dropbox-content" />
                  </button>{' '}
                  New Project
                </a>
              )}
            </React.Fragment>
          </li>
        </React.Fragment>
      );
    return (
      isLogin && (
        <div className="header">
          <header
            className={`navbar position-fixed navbar-expand-lg navbar-light py-0 ${
              this.state.activeHeader ? 'active-header' : ''
            }`}
          >
            <Link to="/" className="navbar-brand">
              <img alt="Dream it Reel Logo" src={Logo} />
            </Link>
            {isLogin && (
              <div className="control-container">
                <a
                  className="nav-link dropdown-toggle pr-1 pl-4 sm-notification-show"
                  id="notificationDropdown"
                  data-target="#notification-full-dropdown"
                  role="button"
                  data-toggle="collapse"
                  aria-haspopup="true"
                  aria-expanded="false"
                  onClick={this.handleOpenNotifications}
                >
                  <i
                    className={`icon icon-bell-fill ${
                      isNewNotifications ? 'new-notifications' : 'notifications'
                    }`}
                  />
                </a>
                <a
                  className="navbar-toggler"
                  data-toggle="collapse"
                  data-target="#navbarNavDropdown"
                  aria-controls="navbarNavDropdown"
                  aria-expanded="false"
                  aria-label="Toggle navigation"
                  onClick={() => {
                    this.notificationsRef.current.classList.remove('show');
                    this.setState({
                      activeNotifications: false,
                      activeHeader: !this.state.activeHeader,
                    });
                  }}
                >
                  <span className="navbar-toggler-icon active" />
                </a>
              </div>
            )}
            {isLogin && (
              <React.Fragment>
                <div
                  ref={this.notificationsRef}
                  className={`dropdown-menu dropdown-menu-notification lg-notifications-hide dropdown-menu-right t-16 row px-1 ${
                    this.state.activeNotifications ? 'show' : ''
                  }`}
                  aria-labelledby="notificationDropdown"
                >
                  <NotificationList
                    notifications={notifications}
                    popup
                    onClick={this.handleCloseNotifications}
                    onNotificationClick={dispatchMarkAsRead}
                  />
                </div>
                <div
                  ref={this.dropdownRef}
                  className="collapse navbar-collapse t-14 py-4 py-lg-0"
                  id="navbarNavDropdown"
                >
                  <ul className="navbar-nav ml-auto d-lg-flex align-items-lg-center lg-navbar-show">
                    {locationHeaders}
                    <li className="nav-item dropdown py-3">
                      <a
                        className="nav-link dropdown-toggle pr-1 pl-4"
                        id="notificationDropdown"
                        role="button"
                        href=""
                        data-toggle="dropdown"
                        aria-haspopup="true"
                        aria-expanded="false"
                        onClick={this.handleOpenNotifications}
                      >
                        <i
                          className={`icon icon-bell-fill ${
                            isNewNotifications
                              ? 'new-notifications'
                              : 'notifications'
                          }`}
                        />
                      </a>
                      <div
                        className="dropdown-menu dropdown-menu-notification dropdown-menu-right t-16 row px-1 sm-notification-show-full"
                        aria-labelledby="notificationDropdown"
                        id="notification-full-dropdown"
                      >
                        <NotificationList
                          notifications={notifications}
                          popup
                          onClick={this.handleCloseNotifications}
                          onNotificationClick={dispatchMarkAsRead}
                        />
                      </div>
                    </li>
                    <li className="nav-item dropdown py-3">
                      <a
                        className="nav-link dropdown-toggle font-weight-light text-gray-2 t-17 px-1"
                        href=""
                        id="navbarDropdownMenuLink"
                        role="button"
                        data-toggle="dropdown"
                        aria-haspopup="true"
                        aria-expanded="false"
                      >
                        <span
                          className="nav-item-avatar"
                          style={{
                            backgroundImage: `url(${
                              !isEmpty(avatarUrl) ? avatarUrl : ProfilePic
                            })`,
                          }}
                        />
                      </a>
                      <div
                        className="dropdown-menu t-15 o-right"
                        aria-labelledby="navbarDropdownMenuLink"
                      >
                        <a
                          className="dropdown-item font-weight-mid text-uppercase"
                          onClick={this.handleGoToProfile}
                        >
                          Edit Profile
                        </a>
                        <a
                          className="dropdown-item font-weight-mid text-uppercase border-top"
                          onClick={this.handleLogout}
                        >
                          Log out
                        </a>
                      </div>
                    </li>
                  </ul>
                  <div className="sm-navbar-show">
                    <ul className="mobile-nav-links">
                      {mobileLocationHeaders}
                    </ul>
                    <div className="mobile-profile-dropdown">
                      <a
                        className="nav-link dropdown-toggle font-weight-light text-gray-2 t-17 px-1 mobile-profile-pic"
                        href=""
                        id="navbarDropdownMenuLink"
                        role="button"
                        aria-haspopup="true"
                        aria-expanded="false"
                        onClick={() => {
                          this.handleGoToProfile();
                          this.dropdownRef.current.classList.remove('show');
                          this.notificationsRef.current.classList.remove(
                            'show',
                          );
                          this.setState({
                            activeNotifications: false,
                            activeHeader: false,
                          });
                        }}
                      >
                        <span
                          className="nav-item-avatar"
                          style={{
                            backgroundImage: `url(${
                              !isEmpty(avatarUrl) ? avatarUrl : ProfilePic
                            })`,
                          }}
                        />
                      </a>
                      <a
                        className="text-primary mobile-logout-link"
                        onClick={this.handleLogout}
                      >
                        Log Out
                      </a>
                    </div>
                  </div>
                </div>
              </React.Fragment>
            )}
          </header>
        </div>
      )
    );
  }
}

Header.propTypes = {
  user: PropTypes.object,
  isLogin: PropTypes.bool,
  handleLogout: PropTypes.func,
  match: PropTypes.shape({
    params: PropTypes.shape({
      project_id: PropTypes.number,
    }),
  }),
  location: PropTypes.shape({
    pathname: PropTypes.string,
  }),
  history: PropTypes.shape({
    push: PropTypes.func,
    goBack: PropTypes.func,
    replace: PropTypes.func,
  }),
  isNewNotifications: PropTypes.bool,
  handleGetNotifications: PropTypes.func,
  dispatchCreateNewProject: PropTypes.func,
  dispatchResetWizard: PropTypes.func,
  notifications: PropTypes.array,
  dispatchMarkAsRead: PropTypes.func,
};

const mapStateToProps = state => {
  const overviewStep = state.overview.currentStep;
  const currentOnboardingSteps = state.onboarding;
  const { overviewSteps } = state.overview;

  return {
    currentOverviewSteps: overviewSteps,
    currentOverviewStep: overviewStep,
    currentOnboardingStep: state.onboarding.currentStep,
    currentOnboardingSteps,
  };
};

const mapDispatchToProps = dispatch => ({
  dispatchCreateNewProject: loggedUser =>
    dispatch(createNewProject(loggedUser)),
  dispatchResetWizard: () => dispatch(resetWizard()),
  dispatchMarkAsRead: notification =>
    dispatch(updateNotification(notification)),
});

export { Header };
export default connect(
  mapStateToProps,
  mapDispatchToProps,
)(withRouter(Header));



// WEBPACK FOOTER //
// ./src/components/Header/Header.js